import { useParams } from "wouter";
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { HomeIcon } from '@heroicons/react/24/outline';
import { AuthContext } from "../contexts/auth"
import { Link } from "wouter";
import CuTable from "../components/cu_table";
import DocsTable from "../components/docs_table";
import DipendentiTable from "../components/dipendenti_table";

import Modal from '../components/modal'
import CardCaricaBp from '../components/card_carica_bp'
import CardCaricaCu from '../components/card_carica_cu'
import { useAtom } from "jotai";
import { currentPageStore } from "../stores/mainStore";
import CheckPermissions from "../components/check_permissions";
import PopoverComponentCustom from "../components/popover_component";
import Footer from "../components/footer";
import V2BusteTable from "../components/buste_table_V2";



export default function ResourceList() {
  const { resourceType } = useParams();
  const [isOpen, setIsOpen] = useState(false)
  const [forceFetch, setForceFetch] = useState(0);

  const [currentPage, setCurrentPage] = useAtom(currentPageStore)

  useEffect(() => {
    if (resourceType) {
      setCurrentPage(resourceType)
    }
  }, [resourceType])



  const { profile, token } = useContext(AuthContext)

  const isProfileComplete = profile.has_complete_profile;

  const closeIt = (val) => {
    setIsOpen(val)
    if(isOpen && !val) {
      setForceFetch(prev => prev + 1)
    }
  };

  // const updateData = () => {
  //   console.log('updateData')
  //   // emit an event to update the data
  //   window.dispatchEvent(new Event('updateDataHR'))
  // }

  const titlesMap = {
    cu: "Lista CU",
    buste: "Lista Buste Paga",
    documenti: "Lista Documenti",
    dipendenti: "Lista Dipendenti"
  };

  const isEmployee = profile.customer_type === 'employee';
  const hasViewDocsPermission =
    !isEmployee ||
    (
      isEmployee &&
      (
        profile.employee?.permissions?.includes('hr.view_docs_ou') ||
        profile.employee?.permissions?.includes('hr.view_docs_all')
      )
    );

  return <>
    <div className="flex flex-col min-h-screen">
      <PopoverComponentCustom title={titlesMap[resourceType] || ""} />

      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="flex-grow mt-10 pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* back button */}
          {hasViewDocsPermission && (
            <>
              {resourceType !== 'documenti' && (
                <div className="flex items-center my-4">
                  <Link to={'/'} className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600"><HomeIcon className="h-4 w-4 inline-block" /> Home</Link>
              
                  {['cu', 'buste'].includes(resourceType || '') && 
                  <button type="button" className={`inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
                    resourceType === 'cu' ? 'cuCaricoMassivo secondStepCu terzoStepCu quartoStepCu quintoStepCu tourNextStep3' : 'busteCaricoMassivo secondStepBuste terzoStepBuste quartoStepBuste quintoStepBuste tourNextStep2'
                  }`}
                    onClick={() => {setIsOpen(true)}}
                  >
                    Carica Massivamente
                  </button>}
            
                </div>
              )}
            </>
          )}
          
          {/* a div with a fake table */}
          <div className={`bg-white rounded-lg ${resourceType === 'documenti' ? '' : 'shadow'} overflow-hidden firstStepDocumenti secondStepDocumenti thirdStepDocumenti tourNextStep4`}>
            {/* switch case based on resourceType */}
            {resourceType === 'cu' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <CuTable key={forceFetch} loading={true} forceFetch={forceFetch} token={token} />
              </CheckPermissions>
            )}
            {/* {resourceType === 'buste' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <BusteTable loading={true} forceFetch={forceFetch} token={token} />
              </CheckPermissions>
            )} */}
            {resourceType === 'buste' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <V2BusteTable key={forceFetch} loading={true} forceFetch={forceFetch} token={token} />
              </CheckPermissions>
            )}
            {resourceType === 'documenti' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <DocsTable token={token} />
              </CheckPermissions>
            )}
            {resourceType === 'dipendenti' && <DipendentiTable loading={true} token={token} />}
          </div>
        </div>
      </main>
      <Footer />
    </div>
    { resourceType == 'buste' && <Modal isOpen={isOpen} setClose={closeIt}>
      <CardCaricaBp setClose={closeIt} />
    </Modal>}
    { resourceType == 'cu' && <Modal isOpen={isOpen} setClose={closeIt}>
      <CardCaricaCu setClose={closeIt} />
    </Modal>}
  </>;
}